hrd.dashboard.prepareLoadingSplashScreen = function(options) {
	options = options || {};
	let loadingTmp = `
		<div id="loader">
			<div id="loader-bg"></div>
			<div class="spinner-container" style="display:none;"></div>
		</div>`;

	$('body').prepend(loadingTmp).css('overflow', 'hidden');
	$('#layout').removeClass('ui-helper-hidden');

	/* dynamic background resource */
	if (!options.ignoreBgImage) {
		let toolbox = new hrd.Toolbox();
		let screensBackgroundImage = toolbox.get('globals.prefs.tenant.layout.screensBackgroundImage', hrd, undefined);
		let bgUri, bgSize, bgPosX, bgPosY;
		if (screensBackgroundImage != undefined) {
			document.documentElement.style.setProperty('--image-home-bg', `url("${hrd.globals.downloadURI}?uid=${screensBackgroundImage.uid}")`);
			bgUri = `url("${hrd.globals.downloadURI}?uid=${screensBackgroundImage.uid}")`;
			bgSize = toolbox.get('globals.prefs.tenant.layout.screensBackgroundSize', hrd, 'cover');
			bgPosX = toolbox.get('globals.prefs.tenant.layout.screensBackgroundPositionX', hrd, 'center');
			bgPosY = toolbox.get('globals.prefs.tenant.layout.screensBackgroundPositionY', hrd, 'center');
		} else {
			bgUri = `url("${hrd.globals.contextRoot}/media/themes/flat/images/homepage/background-home.jpg")`;
			bgSize = 'cover';
			bgPosX = 'center';
			bgPosY = 'center';
		}
		$('#loader-bg').css({
			'backgroundImage': bgUri,
			'backgroundSize': bgSize,
			'backgroundPositionX': bgPosX.toLowerCase(),
			'backgroundPositionY': bgPosY.toLowerCase()
		});

		if($('body.chroma-flow').length > 0) {
			$('#layout').css({
				'backgroundImage': bgUri,
				'backgroundSize': bgSize,
				'backgroundPositionX': bgPosX.toLowerCase(),
				'backgroundPositionY': bgPosY.toLowerCase()
			});
		}
	}
	if (options.bgColor) {
		$('#loader-bg').css({
			'background-color': options.bgColor
		});
	}
}

hrd.dashboard.showLoadingSplashScreen = function(msg, options) {
	let settings = $.extend({}, {
		startDuration: 1000,
		endDuration: 3000,
		resize: true
	}, options);
	msg = msg || 'Loading...';
	// var spinner = '<div class="spinner">' +
	// '  <div class="dot1"></div>' +
	// '  <div class="dot2"></div>' +
	// '</div>';

	var spinner = `<div class="spinner square"></div>`;

	$('.spinner-container', '#loader')
		.show()
		.html(`<div class="header"><span>${msg}</span></div>${spinner}`);

	$.timeout(0, settings).then((settings) => this.fadeOutLoadingWhenCompleted(settings));
}

hrd.dashboard.fadeOutLoadingWhenCompleted = function(options) {
	let closeWhen = options.closeWhen;

	if (closeWhen) {
		closeWhen.then(() => this.closeSplashScreen(options));
	} else if ($.active == 0) {
		this.closeSplashScreen(options);
	} else {
		$.timeout(0, options).then((settings) => this.fadeOutLoadingWhenCompleted(settings));
	}
}

hrd.dashboard.closeSplashScreen = function(options) {
	$("#loader")
		.delay(options.startDuration)
		.effect('fade', {}, options.endDuration, () => {
			$('body').css('overflow', '');
			if (options.resize) {
				$(window).trigger('resize');
			}
			// this.runPostLoad(); // useless, removed because already called on ajaxComplete of last ajax request
		});
}

